import React from 'react';
import styled from '@emotion/styled';
import OrdersLoadingTable, { ORDERS_TABLE_CLASS_NAME } from './OrdersLoadingTable';
import ViewHeader from './ViewHeader';

const OrdersLoadingView = () =>
  <StyledContainer>
    <ViewHeader>Orders</ViewHeader>
    <OrdersLoadingTable />
  </StyledContainer>;

export const StyledContainer = styled.div`
  padding: 0px 60px 60px 60px;
  min-height: 100%;

  .${ORDERS_TABLE_CLASS_NAME} {
    margin-left: -45px;
    margin-right: -45px;
    width: 100%;
  }
`;

export default OrdersLoadingView;
